module.exports = __webpack_public_path__ + "img/arrow_up.24a93bb6.svg";